/**
 * The browse groups alone, for client code: the gallery's chips and its
 * `?type=` reading need the ids, not the taxonomy's definitions (which
 * would ship ~10 KB of classifier text into every gallery bundle). The
 * category → group map lives in `taxonomy.ts`.
 */
export const EMAIL_CATEGORY_GROUPS = [
  'welcome-onboarding',
  'newsletter',
  'content',
  'events',
  'product-news',
  'sales',
  'retention',
  'company',
  'transactional',
  'internal',
  'other',
] as const

export type EmailCategoryGroup = (typeof EMAIL_CATEGORY_GROUPS)[number]

export function isEmailCategoryGroup(
  value: string
): value is EmailCategoryGroup {
  return (EMAIL_CATEGORY_GROUPS as ReadonlyArray<string>).includes(value)
}
